import { AxiosError } from 'axios';

export class HttpError extends Error {
  data: any;

  constructor(error: AxiosError) {
    super(error.message);
    this.name = 'HttpError';
    this.data = error.response.data;
  }
}
